import {Vue} from "ui.vue";

export default {
	name: "CitrusCommonPagination",
	template: `
		<div>
		<div v-if="hasShowMoreBtnAtLeastOne" class="block-line main-page__button-block">
			<a
				href="javascript:void(0)"
				class="qc-button qc-button__outline"
				:class="[btnClass, {'b-btn_loading': loadingAtLeastOne}]"
				@click="showMore"
				v-html="loc.CITRUS_VUE_PAGINATION_LOAD_MORE"
			></a>
		</div>
		</div>`,
	props: {
		paginations: {
			type: Object,
			default: () => {
				return {};
			}
		},
		loading: {
			type: Object,
			required: false,
			default: () => {
				return {};
			}
		},
		btnClass: {
			type: [String, Boolean, null],
			required: false,
			default: ''
		},
		preloading: {
			type: Boolean,
			default: false
		},
	},
	data: function () {
		return {
			currentPage: {},
			shownItems: {},
			hasShowMoreBtn: {},
		};
	},
	created: function () {
		this.initPagination();
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases("CITRUS_VUE_PAGINATION_");
		},
		loadingAtLeastOne() {
			for (let code in this.loading) {
				if (this.loading[code]) {
					return true;
				}
			}

			return false;
		},
		hasShowMoreBtnAtLeastOne() {
			for (let code in this.hasShowMoreBtn) {
				if (this.hasShowMoreBtn[code]) {
					return true;
				}
			}

			return false;
		}
	},
	watch: {
		paginations: {
			handler() {
				this.initPagination();
			},
			deep: true
		},
	},
	methods: {
		initPagination: function () {
			for (let code in this.paginations) {
				let params = this.paginations[code];

				this.$set(this.currentPage, code, !params.hasOwnProperty('currentPage') ? 1 : parseInt(params.currentPage));

				if (this.preloading) {
					this.$set(this.shownItems, code, params.shownItems);
					this.$set(this.hasShowMoreBtn, code, (parseInt(params.recordCount) - this.shownItems[code]) > 0);
				}
				else {
					this.$set(this.hasShowMoreBtn, code, this.currentPage[code] != params.pagesCount);
				}
			}
		},

		/**
		 * Подгрузка элементов через кнопку `Показать ещё`
		 */
		showMore: function () {
			if (!this.preloading && this.loadingAtLeastOne) {
				return false;
			}

			for (let code in this.currentPage) {
				if (this.hasShowMoreBtn[code]) {
					if (this.preloading) {
						this.$emit('next-page', {code: code});
					}
					else {
						this.$emit('page-changed', {
							code: code,
							pageNumber: this.currentPage[code] + 1,
							pageParam: this.paginations[code].pageParam
						});
					}
				}
			}
		}
	}
};
